import React from 'react'
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import ReviewSlider from './components/ReviewSlider';
import FaqSection from './components/FaqSection';
import StillSection from './components/StillSection';
import WhyUs from './components/WhyUs';

const ConsumerHome = () => {
    return (
        <>
            <HeroSection />
            <FeatureSection />
            <WhyUs />
            <ReviewSlider />
            <FaqSection />
            <StillSection />
        </>
    )
}

export default ConsumerHome;